import { areNumbersAlmostEqual } from '../math/areNumbersAlmostEqual';

/**
 * Updates and returns the new cues list wit a modified cue, resorting the cues array to preserve time order if necessary.
 * @param {{id:number, time:number}} changedCue
 * @param {array} cues
 * @returns New instance of the cues list updated
 */
export function updateCueInCues(changedCue, cues) {
  const updatedCues = cues.map((cue) =>
    cue.id == changedCue.id ? changedCue : cue
  );
  return hasCuesOrderChanged(changedCue, cues)
    ? sortCuesByTime(updatedCues)
    : updatedCues;
}
/**
 * Inserts a cue  and returns the new cues list, resorting the cues array to preserve time order if necessary.
 * @param {{id:number, time:number}} cueToInsert The cue to be inserted
 * @param {array} cues
 * @returns {array} New instance of the cues list updated
 */
export function insertCueInCues(cueToInsert, cues) {
  const updatedCues = [...cues, cueToInsert];
  return sortCuesByTime(updatedCues);
}

/**
 * Removes a cue  and returns the new cues list, resorting the cues array to preserve time order if necessary.
 * @param {{id:number, time:number}} cueToRemove The cue to be removed
 * @param {array} cues
 * @returns {array} New instance of the cues list updated
 */
export function removeCueFromCues(cueToRemove, cues) {
  return remapCuesIds(cues.filter((q) => q.id != cueToRemove.id));
}

/**
 * Finds the first cue in the array for which the time proprty is between currentTime - samplingTime and currentTime + samplingTime
 * @param {number} time Current time in milliseconds
 * @param {array} cues Array of cues (each cue must have a time property in milliseconds)
 * @param {number} samplingTime Sampling time in milliseconds
 * @returns
 */
export function findCueByTime(time, cues, samplingTime = 100) {
  return cues.find((cue) => {
    return areNumbersAlmostEqual(cue.time * 1000, time * 1000, samplingTime);
  });
}

/**
 * Returns true if the cue time change changes the temporal order of the cues.
 * @param {array} cues Each cue must have time and id properties
 * @param {*} updatedCue
 * @returns {boolean}
 */
export function hasCuesOrderChanged(updatedCue, cues) {
  const oldCueTime = cues[updatedCue.id]?.time;
  const prevCueTime = cues[updatedCue.id - 1]?.time || 0;
  const nextCueTime = cues[updatedCue.id + 1]?.time || Infinity;
  return (
    updatedCue.time != oldCueTime &&
    (updatedCue.time < prevCueTime || updatedCue.time > nextCueTime)
  );
}

export function sortCuesByTime(cues) {
  cues.sort((cA, cB) => cA.time - cB.time);
  return remapCuesIds(cues);
}
export function remapCuesIds(cues) {
  return cues.map((cue, index) => ({
    ...cue,
    id: index,
  }));
}
